<template>
  <v-container
    fluid
    class="pa-0 pl-4"
  >
    <v-row dense>
      <v-col
        cols="10"
        @click="showTimeFrom = !showTimeFrom"
      >
        <TimeSelectorDialog
          :label="$t('timeFrom')"
          @onConfirm="updateTimeFrom"
        />
      </v-col>
    </v-row>
    <v-spacer />
    <v-row dense>
      <v-col
        cols="10"
        @click="showTimeTo = !showTimeTo"
      >
        <TimeSelectorDialog
          :label="$t('timeTo')"
          @onConfirm="updateTimeTo"
        />
      </v-col>
    </v-row>
    <v-row
      dense
      class="pa-0 ma-0"
    >
      <v-col
        cols="5"
        class="pa-0 ma-0"
      >
        <v-btn
          color="red darken-1"
          text
          @click="onCancel"
        >
          {{$t('cancel')}}
        </v-btn>
      </v-col>
      <v-col
        cols="5"
        class="pa-0 ma-0"
      >
        <v-btn
          color="blue darken-1"
          text
          @click="confirmTimeInterval(timeFrom, timeTo)"
          :disabled="timeFrom < timeTo ? false : true"
        >
          {{$t('confirm')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TimeSelectorDialog from "./TimeSelectorDialog"

export default {
  name: "CustomTimeRange",
  components: {
    TimeSelectorDialog
  },
  data() {
    return {
      timeFrom: null,
      timeTo: null,
      showTimeFrom: false,
      showTimeTo: false
    }
  },
  methods: {
    confirmTimeInterval(timeFrom, timeTo) {
      this.timeFrom = null
      this.timeTo = null
      this.$emit('confirmTimeInterval', timeFrom, timeTo)
    },
    onCancel() {
      this.$emit('cancel')
    },
    updateTimeFrom(time) {
      this.timeFrom = time
    },
    updateTimeTo(time) {
      this.timeTo = time
    }
  }
}
</script>

<style scoped>

</style>
